import React from "react";
import { baseUrl } from "../../libs/env";
import { size } from "lodash";
import SubmitButton from "../../components/buttons/SubmitButton";
import NextButton from "../../components/buttons/NextButton";
import PreviousButton from "../../components/buttons/PreviousButton";
import { AccountType, assessmentFlow } from "../../components/constants/constants";
import { Exitbtn } from "../../components/buttons/exitbtn";
export const AssessmentBottomPanel = ({
  currentSection,
  setCurrentSection,
  currentSectionPage,
  IsonRecorder,
  setCurrentSectionPage,
  pagesOfCurrentSection,
  total_sections,
  data,
  isSubmitting,
  isReview
}) => {
  let showNextButton = true;
  let currentNextSection = currentSection;
  let currentNextSectionPage = currentSectionPage;
  if(isReview && data.sections)
  {
    total_sections = data.sections[0].section_number
  }
  if (
    pagesOfCurrentSection === currentNextSectionPage &&
    currentSection !== total_sections
  ) {
    currentNextSection = currentNextSection + 1;
    currentNextSectionPage = 0;
  }

  if (
    currentNextSection === total_sections &&
    pagesOfCurrentSection === currentNextSectionPage
  ) {
    showNextButton = false;
  }

  let backButtonCurrentSection = currentSection;
  let backButtonCurrentPage = currentSectionPage;
  if (isReview || backButtonCurrentSection !== 1) {
    if(currentSectionPage === 1)
     backButtonCurrentSection -= 1;
    else
     backButtonCurrentPage -= 1;
    data &&
      data.sessions &&
      data.sessions.forEach((session) => {
        if (session.section_number === backButtonCurrentPage) {
          backButtonCurrentPage = session.total_pages;
        }
      });
    // backButtonCurrentPage = 6;
  }

  return (
    <div className={currentSectionPage === 1 ? "row gs-4 pe-0" : "row gs-4 pe-0 sm-column-reverse"}>
      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
        {data.user_type === AccountType.STAFF ? (
          <Exitbtn href="javascript:window.open('','_self').close();" />
        ) : isReview ? (
          <Exitbtn href={`${baseUrl}/user/test-performance/${data?.student_assessment_id}`} />
        ) :  null}
      </div>

      <div className={currentSectionPage === 1 && isReview ? "text-end col-lg-8 col-md-8 col-sm-8 col-8 pe-0" : "text-end col-lg-8 col-md-8 col-sm-8 col-8 sm-w-100 pe-0 mb-2"}>
        {isReview || data.user_type === AccountType.STAFF ? ( 
        <div className="col-12 d-flex justify-content-end">
          {(currentSectionPage === 1 && total_sections === 1) ? null : (
            <div className="me-3 d-inline">
              <PreviousButton
                IsonRecorder={IsonRecorder}
                label={"Previous"}
                onClick={() => {
                  setCurrentSection(backButtonCurrentSection);
                  setCurrentSectionPage(
                    parseInt(
                      `${backButtonCurrentSection}${backButtonCurrentPage}`
                    )
                  );
                }}
              />
            </div>
          )}
          {showNextButton  ? (
            <NextButton
              IsonRecorder={IsonRecorder}
              onClick={() => {
                setCurrentSection(currentNextSection);
                setCurrentSectionPage(
                  parseInt(`${currentNextSection}${currentNextSectionPage + 1}`)
                );
              }}
            />
          ): null}
        </div>):
        (
        <div className="">
        {(currentSection === 1 && currentSectionPage === 1) || data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : (
          <div className="me-3 d-inline">
            <PreviousButton
              IsonRecorder={IsonRecorder}
              label={"Previous"}
              onClick={() => {
                setCurrentSection(backButtonCurrentSection);
                setCurrentSectionPage(
                  parseInt(
                    `${backButtonCurrentSection}${backButtonCurrentPage}`
                  )
                );
              }}
            />
          </div>
        )}
        {showNextButton && data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP  ? (
          <NextButton
            IsonRecorder={IsonRecorder}
            onClick={() => {
              setCurrentSection(currentNextSection);
              setCurrentSectionPage(
                parseInt(`${currentNextSection}${currentNextSectionPage + 1}`)
              );
            }}
          />
        ) : data.user_type === AccountType.STUDENT ? (
          <SubmitButton IsonRecorder={IsonRecorder} isSubmitting={isSubmitting} 
          btnContent={data.assessment_flow ===  assessmentFlow.SEQUENTIAL_EARLY_STOP && size(data.sections_pages) > 1 ? 'Next' : 'Submit'}
          />
        ) : null}
        </div>
        )}

      </div>
    </div>
  );
};
